import React from "react";  //keep for backward compatibility with older React versions
import RiskGraph from "../../components/risk-graph";
import GeneTable from "../../components/gene-table";

const Med_Epi_Results = (props) => {
  return (
    <div>
      <div className="title-margins">
        <h2>
          {props.userName
            ? `${props.userName}'${props.nameEndsWithS ? "" : "s"}`
            : ""}{" "}
          Results for Hamstring Strain (Muscle Stiffness)
        </h2>
        <h5>[<a href="https://pubmed.ncbi.nlm.nih.gov/39902889/">Miyamoto-Mikami et al., 2025</a>]</h5>
      </div>
      
      <div className="card">
        <p>
          Directly screening for risk of hamstring strains has been unsuccessful, likely because strains are highly dependent on environmental factors such as training load, type of sport, weather, playing surface, etc. Rather than analyzing hamstring strains directly, <a href="https://pubmed.ncbi.nlm.nih.gov/39902889/">Miyamoto-Mikami et al., 2025</a> analyzed muscle stiffness, because high muscle stiffness also increases risk of hamstring strains.
        </p>
        <p>
          The table shows two SNPs from the GWAS. Two copies of the effect allele indicates increased risk for hamstring strain as shown in the Figure.
        </p>
        <p>
          CCDC73 (Coiled-Coil Domain Containing 73) has roles in protein–protein interactions, scaffolding, and cellular structural organization.
        </p>
        <p>VWA5A (Von Willebrand Factor A Domain Containing 5A) is involved in cell adhesion, extracellular matrix interactions, and protein–protein binding.</p>
        <GeneTable tag="med_epi" cols={[ "gene"]} />
      </div>
<div className="card">
  <div className="axgen-fullbleed-figure">
    <img
      src="/assets/imgs/results/content/strain_snps.png"
      alt=""
      className="axgen-fullbleed-figure__img"
    />
  </div>

  <div className="text-content">
        <p>Associations of the rs7939583 (A) and the rs78405694 (B) with a history of muscle strain injury in athletes. If your genotype from the table is rs78405694 (C/C) or rs7939583 (A/A), you have higher risk of muscle strain. </p>
    
  </div>
</div>
    </div>
  );
};

export default Med_Epi_Results;
